module.exports = __webpack_public_path__ + "images/emoji/sa.4df350cc4f56f666ac6e.png";